import _isMatch from 'lodash/isMatch'

export const matchAction = actionA => actionB => {
  return _isMatch(actionB, actionA)
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js